export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  /**
   * Base URL for the admin-api (OIDC endpoints). Separate from
   * apiBaseUrl so dev can proxy `/v1/auth/*` to :3002 while
   * `/v1/admin/*` stays on :3000. Falls back to same-origin so prod
   * (Caddy routes both) just works.
   */
  authBaseUrl: import.meta.env.VITE_AUTH_BASE_URL ?? '',
}
